import { RouterItem } from '@/utils/interfaces';
import AdminMainLayout from '@/layouts/admin/MainLayout.vue';
import HomeLayout from '@/layouts/admin/HomeLayout.vue';
/** 系统管理 */
const routesMap: RouterItem[] = [
  {
    path: '/system-manage',
    component: AdminMainLayout,
    redirect: '/system-manage/user',
    meta: {
      title: '系统管理',
      icon: 'setting',
    },
    children: [],
  },
  {
    path: '/qrCodeFeedBack/zhpjFeedBack',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'zhpjFeedBack',
        component: () => import('@/views/qrCodeFeedBack/zhpjFeedBack/index.vue'),
      },
    ],
  },
  {
    path: '/qrCodeFeedBack/jspjFeedBack',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'jspjFeedBack',
        component: () => import('@/views/qrCodeFeedBack/jspjFeedBack/index.vue'),
      },
    ],
  },
  {
    path: '/leave/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'leave',
        component: () => import('@/views/leave/index.vue'),
        meta: {
          title: '请假',
        },
      },
    ],
  },
  {
    path: '/leave/my',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'MyLeave',
        component: () => import('@/views/leave/myLeave.vue'),
        meta: {
          title: '我的请假',
        },
      },
    ],
  },
  {
    path: '/leaveApproval/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'LeaveApproval',
        component: () => import('@/views/leaveApproval/index.vue'),
        meta: {
          title: '请假审核',
        },
      },
      {
        path: '/leaveAudit',
        name: 'LeaveAudit',
        component: () => import('@/views/leaveApproval/components/audit.vue'),
        meta: {
          title: '审核',
        },
      },
      {
        path: '/leaveEdit',
        name: 'LeaveEdit',
        component: () => import('@/views/leaveApproval/components/editForm.vue'),
        meta: {
          title: '请假信息修改',
        },
      },
    ],
  },
  {
    path: '/my-question',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'MyQuestion',
        component: () => import('@/views/myQuestion/index.vue'),
        meta: {
          title: '我的问题',
        },
      },
    ],
  },
  {
    path: '/add-question',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'AddQuestion',
        component: () => import('@/views/myQuestion/addQuestion.vue'),
        meta: {
          title: '添加问题',
        },
      },
    ],
  },
  {
    path: '/sign/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'sign',
        component: () => import('@/views/sign/index.vue'),
        meta: {
          title: '签到',
        },
      },
    ],
  },
  {
    path: '/attendance',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'attendance',
        component: () => import('@/views/attendance/index.vue'),
        meta: {
          title: '申请补考勤',
          icon: 'smail-o',
        },
      },
    ],
  },
  {
    path: '/attendanceList',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'attendanceList',
        component: () => import('@/views/attendance/attendanceList.vue'),
        meta: {
          title: '申请补考勤列表',
          icon: 'smail-o',
        },
      },
    ],
  },
  {
    path: '/scheduleList',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'scheduleList',
        component: () => import('@/views/attendance/scheduleList.vue'),
        meta: {
          title: '申请补考勤列表',
          icon: 'smail-o',
        },
      },
    ],
  },
  {
    path: '/classDetail',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'classDetail',
        component: () => import('@/views/classDetail.vue'),
        meta: {
          title: '培训班详情',
          icon: 'smail-o',
        },
      },
    ],
  },
  {
    path: '/platformBind',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'PlatformBind',
        component: () => import('@/views/platformBind/index.vue'),
        meta: {
          title: '网院账号绑定',
          icon: 'smail-o',
        },
      },
    ],
  },
  {
    path: '/experience',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'experience',
        component: () => import('@/views/experience/index.vue'),
        meta: {
          title: '上课心得',
          icon: 'smail-o',
        },
      },
    ],
  },
  {
    path: '/personal',
    component: AdminMainLayout,
    meta: {
      title: '个人设置',
      icon: 'user',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/personal/index.vue'),
        name: 'personal-index',
        meta: {
          title: '个人信息',
        },
      },
    ],
  },
  {
    path: '/signUp/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'signUpIndex',
        component: () => import('@/views/signUp/index.vue'),
        meta: {
          title: '开班报到列表',
        },
      },
    ],
  },
  {
    path: '/signUp/detail',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'signUpDetail',
        component: () => import('@/views/signUp/detail.vue'),
        meta: {
          title: '开班报到详情',
          keepAlive: true, // 此页面需要缓存
          isBack: false, // 用于判断上一个页面是哪个
        },
      },
    ],
  },
  {
    path: '/schedule/index',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'schedule',
        component: () => import('@/views/schedule/index.vue'),
        meta: {
          title: '全部日程',
        },
      },
    ],
  },
  {
    path: '/myTraining/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'training',
        component: () => import('@/views/myTraining/index.vue'),
        meta: {
          title: '我的培训',
        },
      },
    ],
  },
  {
    path: '/myTraining/detail',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'trainingDetail',
        component: () => import('@/views/myTraining/detail.vue'),
        meta: {
          title: '培训班详情',
          keepAlive: true, // 此页面需要缓存
          isBack: false, // 用于判断上一个页面是哪个
        },
      },
    ],
  },
  {
    path: '/myhours/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'myhours',
        component: () => import('@/views/myhours/index.vue'),
        meta: {
          title: '培训情况',
        },
      },
    ],
  },
  {
    path: '/myFeedbacks/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'myFeedbacks',
        component: () => import('@/views/myFeedbacks/index.vue'),
        meta: {
          title: '我的评价',
        },
      },
    ],
  },
  {
    path: '/myFeedbacks/feedback',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'feedback',
        component: () => import('@/views/myFeedbacks/feedback.vue'),
        meta: {
          title: '评价页',
        },
      },
    ],
  },
  {
    path: '/myFeedbacks/reviewedDetail',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'reviewedDetail',
        component: () => import('@/views/myFeedbacks/components/reviewedDetail.vue'),
        meta: {
          title: '已评详情',
        },
      },
    ],
  },
  {
    path: '/myExperience/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'myExperience',
        component: () => import('@/views/myExperience/index.vue'),
        meta: {
          title: '我的心得',
        },
      },
    ],
  },
  {
    path: '/myExperience/component/form',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'experienceForm',
        component: () => import('@/views/myExperience/component/form.vue'),
        meta: {
          title: '填写心得',
        },
      },
    ],
  },
  {
    path: '/trainingDeclaration/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'trainingDeclaration',
        component: () => import('@/views/trainingDeclaration/index.vue'),
        meta: {
          title: '添加我的培训记录',
        },
      },
    ],
  },
  {
    path: '/trainingDeclaration/component/form',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'declarationForm',
        component: () => import('@/views/trainingDeclaration/component/recordForm.vue'),
        meta: {
          title: '申报提交',
        },
      },
    ],
  },
  {
    path: '/trainingDeclaration/component/learningRecordForm',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'LearningRecordForm',
        component: () => import('@/views/trainingDeclaration/component/learningRecordForm.vue'),
        meta: {
          title: '党委（党组）中心组学习记录提交',
        },
      },
    ],
  },
  {
    path: '/personInfo/index',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'personInfo',
        component: () => import('@/views/personInfo/index.vue'),
        meta: {
          title: '个人信息',
        },
      },
    ],
  },
  {
    path: '/personInfo/phone',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'phone',
        component: () => import('@/views/personInfo/phone.vue'),
        meta: {
          title: '手机号码',
        },
      },
    ],
  },
  {
    path: '/personInfo/editUserInfo',
    component: AdminMainLayout,
    children: [
      {
        path: '',
        name: 'editUserInfo',
        component: () => import('@/views/personInfo/components/form.vue'),
        meta: {
          title: '修改个人信息',
        },
      },
    ],
  },
];
export default routesMap;
